// Angular modules.
import { Injectable } from '@angular/core';
import { FreudMessageService } from '@freud-ds/web-components';
import { ApiErrorResponse } from 'app/interfaces/error.interface';
import { Observable, Subject } from 'rxjs';

import { ErrorService } from './error.service';

@Injectable()
export class NotificationsService {
	private mustShowEvent = new Subject<string>();

	// Constructor method.
	constructor(
		private errorService: ErrorService,
		private toastr: FreudMessageService
	) {}

	// Force to show details of an event.
	public showEventDetails(id: string): void {
		this.mustShowEvent.next(id);
	}

	// Aux for new online sessions emitter.
	public getEventToShowDetails(): Observable<any> {
		return this.mustShowEvent.asObservable();
	}

	showSuccess(message: string, title?: string) {
		this.toastr.add({
			severity: 'success',
			detail: message.replace('\n', '<br/>'),
			summary: title,
			life: 3000,
		});
	}

	showError(message: ApiErrorResponse | string, title?: string) {
		if (message) {
			if (typeof message === 'string') {
				this.toastr.add({
					severity: 'error',
					detail: message.replace('\n', '<br/>'),
					summary: title,
					life: 5000,
				});
			} else {
				this.toastr.add({
					severity: 'error',
					detail: this.errorService
						.getMessage(message.error)
						.replace('\n', '<br/>'),
					summary: title,
					life: 5000,
				});
			}
		}
	}

	showInfo(message: string, title?: string) {
		this.toastr.add({
			severity: 'success',
			detail: message.replace('\n', '<br/>'),
			summary: title,
			sticky: true,
			closable: true,
		});
	}

	showWarning(message: string, title?: string) {
		this.toastr.add({
			severity: 'warning',
			detail: message.replace('\n', '<br/>'),
			summary: title,
		});
	}
}
